"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { initPostHog, trackPageView, startPageTimer, endPageTimer } from "@/lib/tracking/posthog";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    // Initialize PostHog
    initPostHog();
  }, []);

  useEffect(() => {
    // Track page views and time spent
    if (pathname) {
      const url = window.location.href;
      const pageName = pathname;

      // End timer for previous page if it exists
      const previousPage = sessionStorage.getItem("current_page");
      if (previousPage && previousPage !== pageName) {
        endPageTimer(previousPage);
      }

      // Start timer for current page
      startPageTimer(url);
      sessionStorage.setItem("current_page", url);

      // Track page view
      trackPageView(url, {
        page: pageName,
        search_params: window.location.search,
      });
    }
  }, [pathname]);

  // Handle page unload to capture time spent on last page
  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentPage = sessionStorage.getItem("current_page");
      if (currentPage) {
        endPageTimer(currentPage);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return <>{children}</>;
}
